import React, { useEffect, useState } from 'react'
import NavBar from './NavBar'

export default function Header() {
  const [visible, setVisibility] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      // Verifica se o scroll passou de 200
      if (window.innerWidth > 1180 && window.scrollY > 200) {
        setVisibility(false)
        return
      }
      setVisibility(true)
      return
    }
    // Adiciona o evento de scroll
    window.addEventListener('scroll', handleScroll)

    // Limpeza do event listener
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  return (
    <header
      className="app-header"
      style={!visible ? { transform: 'translateY(-44px)' } : {}}
    >
      <NavBar />
    </header>
  )
}
